<template>
  <div
    id="tab-gathering-trailer"
  >
    <el-form
      :disabled="readonly"
      class="section"
      style="flex-direction: row;width: fit-content;min-width: 1345px"
    >
      <el-checkbox
        v-model="form.landTransportation"
        no="landTransportation"
        @change="pm.loadingTermChange('landTransportation')"
      >{{ $t('Partners.doorInformation') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.dischargingPortDoor"
        no="dischargingPortDoor"
        style="margin-left: -20px;"
      >{{ $t('CargoMsg.Cargo_DestinationDelivery') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.warehousing"
        no="warehousing"
        style="margin-left: -20px;"
        @change="pm.loadingTermChange('warehousing')"
      >{{ $t('SeaExport.WarehouseLoading') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px;"
        @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}
      </el-checkbox>
      <el-checkbox v-model="form.insure" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
    </el-form>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="133px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ConsignInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input
                :value="form.jobNo"
                :disabled="true"
              />
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => p.statusEnabled && p.intergraed"
                  :default-value="form.saleProductCode || ''"
                  @parentCallBack="p => {form.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="form.fullOrInside || ''"
                  @parentCallBack="p => {form.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.ConsignationCompany') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageB"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="form.customerId&&readonly?'':'not-click'"
                    :src="sopPic"
                    width="18"
                    height="28"
                    style="padding: 5px 0;vertical-align: bottom; cursor: pointer"
                    @click="pm.sopChangeCustomerIdHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageB"
                  :content="warningImageBTip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-sales-company-select
                  ref="customerSelect"
                  no="customerId"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,active:true,companyLob:'integratedJob'}"
                  :check-credit="true"
                  :default-value="form.customerId||''"
                  :disabled="!customerEnabled"
                  style="flex: 1;"
                  :job="form"
                  @parentCallBack="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span
                  v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                  class="orange"
                >LV{{ customerLevel.level }}</span>
                <span
                  v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                  style="color:#D3A73B"
                >&nbsp;{{ customerLevel.customerName }}</span>
                <span
                  v-show="contractStatusLabel"
                  class="red"
                >&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.ContactPerson')"
            >
              <div style="display: flex">
                <el-select
                  v-model="form.customerContact"
                  no="customerContact"
                  filterable
                  :allow-create="true"
                >
                  <el-option
                    v-for="(item,index) in contactList"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>&nbsp;
                <el-link
                  v-show="!isShowContactPersonDetail"
                  no="customerContactLink"
                  :class="form.customerContact?'':'not-click'"
                  @click="showContactDialog"
                >{{ $t('SeaExport.Detail') }}
                </el-link>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="cargoType"
                :select-type="selectTypeNames.basic_data_CargoType"
                :method-params="{sea:true}"
                filterable
                :clearable="false"
                :default-value="form.cargoType"
                @parentCallBack="p=>{form.cargoType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input
                :value="form.salesChannel"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input :value="form.trustFromJob" :disabled="true" />
            </el-form-item>
            <!--综合物流订单类型-->
            <el-form-item :label="$t('SeaExport.ComprehensiveLogisticsOrderType')">
              <el-select
                :value="form.containerLoadType"
                no="containerLoadType"
                :disabled="isSelectDisabled || hasMaster"
                @change="val=>{pm.containerLoadTypeChange(val)}"
              >
                <el-option
                  v-for="(item,index) in (containerLoadTypes)"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <!--操作模式-->
            <el-form-item :label="$t('SeaExport.OperateType')">
              <el-select
                :value="form.operateType"
                :disabled="hasMaster"
                no="operateType"
                @change="val=>{pm.operateTypeChange(val)}"
              >
                <el-option
                  v-for="(item,index) in (operateTypes)"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportType')">
              <cargo-advance-select
                no="cargoType"
                :select-type="selectTypeNames.basic_data_TransportType"
                :method-params="{ie:true}"
                filterable
                :clearable="false"
                :default-value="form.transportType"
                @parentCallBack="p=>{form.transportType=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_BusinessDate') }}</span>
              <div style="display: flex">
                <el-date-picker
                  no="businessDate"
                  class="departure-date-picker"
                  :value="form.businessDate"
                  :disabled="provisionEtdLocked"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                  @input="businessDateChange"
                />&nbsp;
                <span>{{ form.businessDateDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_estEtd') }}</span>
              <div style="display: flex">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="form.etd"
                  :disabled="hasMaster"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                  @input="etdChange"
                />&nbsp;
                <span>{{ form.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_actAtd') }}</span>
              <div style="display: flex">
                <el-date-picker
                  :value="form.atd"
                  :disabled="hasMaster"
                  no="atd"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="atdChange"
                />
                <span>{{ form.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_estEta') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.eta"
                  :disabled="hasMaster"
                  no="eta"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="etaChange"
                />
                <span>{{ form.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_actAta') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.ata"
                  :disabled="hasMaster"
                  no="ata"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="ataChange"
                />
                <span>{{ form.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="form.customsDate"
                no="customsDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptCodeOnBl')">
              <cargo-advance-select
                no="dispatchingPlaceCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                :placeholder="$t('SeaExport.PlaceHolderPOR')"
                filterable
                :default-value="form.dispatchingPlaceCode"
                tag-name="englishName"
                style="flex:1"
                @parentCallBack="p=>{pm.changeDispatchingPlaceCode(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_dispatchingPlace')">
              <el-input
                v-model="form.dispatchingPlace"
                no="dispatchingPlace"
                @change="pm.changeDispatchingPlace()"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_loadingPortCode') }}</span>
              <div style="display: flex; justify-content: space-between">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :disabled="hasMaster"
                  filterable
                  :default-value="form.loadingPortCode"
                  tag-name="englishName"
                  style="flex:1"
                  @parentCallBack="p=>{loadingPortCodeCharge(p);pm.setPlannerChange()}"
                />&nbsp;
                <el-checkbox v-model="form.transfering" :disabled="hasMaster" no="transfering" style="padding-left:2px;">{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.transfering"
              :label="$t('CargoMsg.Cargo_transferPortCode')"
            >
              <cargo-advance-select
                no="transferPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                :disabled="hasMaster"
                filterable
                :default-value="form.transferPortCode"
                @parentCallBack="p=>{form.transferPortCode=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_dischargingPortCode') }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                :disabled="hasMaster"
                filterable
                :default-value="form.dischargingPortCode"
                @parentCallBack="p=>{form.dischargingPortCode=p.value;pm.dischargingPortCodeChange(p.value);}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WaybillDestination')">
              <el-input
                v-model="form.waybillDestination"
                no="waybillDestination"
                type="textarea"
                :rows="5"
                @change="pm.changeDispatchingPlace()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Carrier')">
              <cargo-company-select
                no="carrierId"
                :disabled="!carrierIdEnabled || hasMaster"
                :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
                :default-value="form.carrierId||''"
                @change="p=>{form.carrierId=p.value;onCarrierIdChange()}"
                @blur="pm.carrierFocusOutEventHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PolCountry')">
              <el-input v-model="form.polCountry" no="polCountry" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="form.cargoSource"
                no="cargoSource"
                :disabled="!cargoSourceEnabled"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
              >
                <el-option
                  v-for="(item,index) in CARGO_SOURCES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
            <!--自定义业务类型-->
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :default-value="form.customJobType"
                :method-params="{type:form.lob}"
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="form.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="form.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="form.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.statisticArea=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_destinationAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageC"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="form.destinationAgent&&readonly?'':'not-click'"
                    :src="sopPic"
                    width="18"
                    height="28"
                    style="padding: 5px 0;cursor: pointer"
                    @click="pm.sopChangeHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageC"
                  :content="warningImageCTip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-advance-select
                  no="destinationAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{overseaAgent:true,companyLob:'integratedJob',active:true}"
                  :default-value="form.destinationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item v-show="form.cargoSource === 'NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageA"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :class="form.designationAgent&&readonly?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      height="28"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeBookingAgentHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageA"
                  :content="warningImageATip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-advance-select
                  no="designationAgent"
                  class="designation-agent-selector"
                  popper-class="designation-agent-selector-popper"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!designationAgentEnabled"
                  :method-params="{designationAgent:true,companyLob:'integratedJob',active:true}"
                  :check-credit="true"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="bookingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,companyLob:'integratedJob',active:true}"
                filterable
                :default-value="form.bookingAgent||''"
                @parentCallBack="p=>{form.bookingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_transferAgent')">
              <cargo-advance-select
                no="transferAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{portAgent:true,companyLob:'integratedJob',active:true}"
                filterable
                :default-value="form.transferAgent||''"
                @parentCallBack="p=>{form.transferAgent=p.value}"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" style="width: 400px;">
          <el-form
            :disabled="readonly"
            label-width="135px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.AdditionalInformation') }}</span>
            <el-form-item
              id="customerRefNo"
              :label="$t('SeaExport.BusinessReferenceNo')"
            >
              <el-tooltip
                :disabled="!customerRefNoTip"
                :content="customerRefNoTip"
                placement="right-end"
              >
                <el-input
                  v-model="form.customerRefNo"
                  no="customerRefNo"
                  :class="customerRefNoTip?'red':''"
                  @blur="pm.customerRefNoFocusOutHandler()"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <el-input
                v-if="!openProjectConfig"
                v-model="form.poNo"
                no="poNo"
              />
              <cargo-project-select
                v-if="openProjectConfig"
                no="poNo"
                :default-value="form.poNo"
                :customer-id="form.customerId"
                :is-linked="isProjectLinkedCustomer"
                @change="p=>{form.poNo=p.value;form.projectName=p.projectName;changeProject()}"
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="form.projectName" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="form.projectBatch" no="projectBatch" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="customsBroker"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :default-value="form.customsBroker||''"
                :placeholder="!customsBrokerEnabled? $t('SeaExport.PleaseTickCustomsDeclarationOption'):$t('CargoMsg.Cargo_keyWordsTip')"
                :method-params="{customsBroker:true,companyLob:'integratedJob',active:true}"
                @parentCallBack="p=>{form.customsBroker=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{form.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethodPol"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                filterable
                :clearable="false"
                :default-value="form.customsMethodPol"
                @parentCallBack="p=>{form.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                filterable
                :default-value="form.tradeTerm"
                @parentCallBack="p=>{form.tradeTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-company-select
                no="carryingCmp"
                :disabled="!form.landTransportation"
                :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
                :default-value="form.carryingCmp||''"
                :placeholder="!form.landTransportation?$t('SeaExport.PleaseTickDoorLoadingDeliveryOption'):$t('CargoMsg.Cargo_keyWordsTip')"
                @change="p=>{pm.carryingCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="(openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse'))">
              <cargo-company-select
                no="warehouseCmp"
                :disabled="!warehouseEabled"
                :method-params="{warehouse:true,active:true,companyLob:'integratedJob'}"
                :default-value="form.warehouseCmp||''"
                :placeholder="!warehouseEabled? $t('SeaExport.PleaseSelectWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse" :label="$t('SeaExport.WareHouseName')">
              <el-select
                ref="warehouseName"
                v-model="form.warehouseName"
                no="warehouseName"
                :disabled="!warehouseEabled||!form.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SpecialPriceInstructions')">
              <el-input v-model="form.salePriceRemarks" no="salePriceRemarks" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDemurrage')">
              <el-input v-model="form.freeDemurrage" no="freeDemurrage" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDetention')">
              <el-input v-model="form.freeDetention" no="freeDetention" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsAreaApplication')">
              <el-input v-model="form.customsAreaApplication" no="customsAreaApplication" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                :clearable="false"
                :default-value="form.incoTerm"
                @parentCallBack="p=>{form.incoTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="form.paymentTermMBL"
                @parentCallBack="p=>{form.paymentTermMBL=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="form.userDefinedField1"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="form.userDefinedField2"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="form.userDefinedField3"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="form.userDefinedField4"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="form.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="120px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <el-form-item
              :label="$t('SeaExport.QuantityConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  @change="pm.jobContractQwcChange(1)"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="quantityActual"
                  v-model="form.quantityActual"
                  no="quantityActual"
                  :precision="0"
                  :disabled="pm.billChargeFlag"
                  :min="0"
                  @change="quantityActualChange"
                />
                <span>PCS</span>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.WeightConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="weightContractChange"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="weightActual"
                  v-model="form.weightActual"
                  no="weightActual"
                  :precision="3"
                  :disabled="pm.billChargeFlag"
                  :min="0"
                  @change="weightActualChange"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.CubageConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  @change="cubageContractChange"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="cubageActual"
                  v-model="form.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :disabled="!cubageActualEnabled"
                  :min="0"
                  @change="cubageActualChange"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Package')"
            >
              <cargo-packing-select
                no="packing"
                :default-value="form.packing"
                @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Pieces')"
            >
              <auto-number-input
                v-model="form.insideQuantity"
                no="insideQuantity"
                :precision="0"
                :min="0"
                @valCallBack="(val)=>{
                  form.insideQuantity = val
                }"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PiecesType')"
            >
              <cargo-packing-select
                no="insidePacking"
                :default-value="form.insidePacking"
                @change="p=>{form.insidePacking=p.value}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.ChargedWeightRT')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.chargeWeight"
                  no="chargeWeight"
                  :precision="3"
                  style="flex:1"
                  :disabled="!chargeWeightEnabled"
                  :min="0"
                  @change="pm.chargeWeightChange();"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item v-show="isEdit">
              <div slot="label">
                <el-button
                  no="Copy2"
                  type="primary"
                  @click="transcribeDialog.visible=true"
                >{{ $t('SeaExport.Copy2') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.EnglishDescriptionOfGoods')"
            >
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <cargo-rich-textarea
                  ref="cargoTextarea1"
                  v-model="form.cargoEnglishName"
                  no="cargoEnglishName"
                  :show-count="true"
                  :text-chars="0"
                  :warning-count="-1"
                  :disabled="!isEdit"
                  wrap-symbol="r"
                  auto-half-word
                  :auto-uppercase="isUppercaseByConfig"
                  style="height: 110px"
                  :class="form.cargoEnglishNameWarning === 1 ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{},true,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Marks')"
            >
              <special-character-tip :texts="specialCharCheck.mark">
                <cargo-rich-textarea
                  ref="cargoTextarea2"
                  v-model="form.mark"
                  no="mark"
                  :show-count="true"
                  :text-chars="0"
                  :warning-count="-1"
                  wrap-symbol="r"
                  auto-half-word
                  :auto-uppercase="isUppercaseByConfig"
                  :disabled="!isEdit"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{},true,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.HsCode') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="Search"
                  type="primary"
                  @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),p=>form.hsCode=p.code)"
                >{{ $t('SeaExport.Search') }}
                </el-button>
              </div>
              <el-input
                v-model="form.hsCode"
                no="hsCode"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="ChineseDescriptionOfGoods"
                  type="primary"
                  @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>form.cargoChineseName=p.commodityName)"
                >{{ $t('SeaExport.Search') }}
                </el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.cargoChineseName"
                no="cargoChineseName"
                :disabled="!isEdit"
                :auto-uppercase="false"
                :auto-half-word="false"
                wrap-symbol="r"
                :class="form.cargoChineseNameWarning === 1 ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,val=>{form.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_waybillInvoice')">
              <el-input
                v-model="form.waybillInvoice"
                no="waybillInvoice"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="108px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.OperationInfo') }}</span>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input
                :value="txtSalesOffice"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  no="sales"
                  :disabled="!(trustFromEditSales || !form.relatedJob)"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="form.sales||''"
                  :static-options="salesList"
                  :placeholder="salesPrompt"
                  :merge-load="true"
                  style="flex: 1"
                  @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
                />&nbsp;
                <el-checkbox
                  v-model="form.provisioned"
                  no="provisioned"
                  style="margin-left: 5px"
                  :disabled="true"
                >{{ $t('SeaExport.Accrued') }}
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="form.cargoSalesId||''"
                :merge-load="true"
                :static-options="cargoSalesList"
                @change="p=>{form.cargoSalesId=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.SalesDepartment') }}</span>
              <cargo-department-new-select
                no="salesOffice"
                :disabled="!form.sales"
                :sales-id="Number(form.sales)"
                :office-id="form.salesOffice"
                :enables="true"
                :department-id="Number(form.salesDepartment)"
                @change="p=>{form.salesDepartment=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="opOffice"
                :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
                :is-regional-commission="isRegionalCommission"
                :office-id="Number(form.opOffice)"
                @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                no="opDepartment"
                :office-id="Number(form.opOffice)"
                :enables="true"
                :department-id="Number(form.opDepartment)"
                @change="p=>{form.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                ref="op"
                no="op"
                :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                :default-value="form.op||''"
                :merge-load="true"
                @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(form.csrOffice)"
                @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(form.csrOffice)"
                :enables="true"
                :department-id="Number(form.csrDepartment)"
                @change="p=>{form.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                ref="csr"
                no="csr"
                :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
                :default-value="form.csr||''"
                :merge-load="true"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                ref="siteOp"
                no="siteOp"
                :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
                :default-value="form.siteOP||''"
                @change="p=>{pm.siteOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                :default-value="form.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : overseaAgentUsersList"
                :merge-load="true"
                @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TruckCustomerService')">
              <cargo-user-select
                ref="truckCsr"
                no="truckCsr"
                :method-params="{officeId:form.opOffice,category:'role',shape:'truckCsr'}"
                :default-value="form.truckCsr||''"
                :merge-load="true"
                @change="p=>{pm.truckCsrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(form.dcOffice)"
                @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(form.dcOffice)"
                :enables="true"
                :department-id="Number(form.dcDepartment)"
                @change="p=>{form.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="dc"
                :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                :default-value="form.dc||''"
                :merge-load="true"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(form.plannerOffice)"
                @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(form.plannerOffice)"
                :enables="true"
                :department-id="Number(form.plannerDepartment)"
                @change="p=>{form.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="planner"
                :method-params="{officeId:form.opOffice,category:'role',shape:'seaLine'}"
                :default-value="form.planner||''"
                :merge-load="true"
                @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="form.userDefinedRoleId1||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="form.userDefinedRoleId2||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <special-requests-grid
              ref="selectedSpecialRequest"
              v-model="form.satisfiedRequests"
              no="satisfiedRequests"
              :is-edit="isEdit"
              :customer-id="Number(form.customerId)"
              :lob="form.lob"
              :job="form"
              style="margin-bottom: 5px"
            />
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-tooltip
                :content="form.operationContent"
                placement="left"
              >
                <div
                  slot="content"
                  v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
                />
                <el-input
                  no="operationContent"
                  :value="form.operationContent"
                  :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
                  type="textarea"
                  :rows="4"
                  @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationTips')">
              <el-input
                v-model="form.operationTips"
                no="operationTips"
                type="textarea"
                :rows="4"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--      客户发运信息-->
      <div class="section">
        <div class="form-row">
          <span class="title">{{ $t('SeaExport.CustomerDeliveryInfo') }}</span>
          <div style="display: flex; flex-direction: row;">
            <el-form
              :disabled="readonly"
              label-width="50px"
              label-position="right"
              style="position:relative;margin-right: 10px"
            >
              <char-count :form="form" prefix="shipper" />
              <el-form-item :label="$t('SeaExport.Shipper')">
                <cargo-company-select
                  no="shipperId"
                  :method-params="{shipper:true,active:true,companyLob:'integratedJob'}"
                  :default-value="form.shipperId||''"
                  style="display: inline-block;width: 175px;"
                  @change="data => {pm.shipperChange(data)}"
                />&nbsp;
                <el-button
                  no="shipperBillAddress"
                  type="primary"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'shipperLine'+i"
                  v-model="form['shipperLine'+i]"
                  :no="'shipperLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),'')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify,null)"
                />
              </el-form-item>
            </el-form>
            <el-form
              :disabled="readonly"
              label-width="50px"
              label-position="right"
              style="position:relative;margin-right:10px"
            >
              <char-count :form="form" prefix="consignee" />
              <el-form-item :label="$t('SeaExport.Consignee')">
                <cargo-company-select
                  no="consigneeId"
                  :method-params="{consignee:true,active:true,companyLob:'integratedJob'}"
                  :default-value="form.consigneeId||''"
                  style="display: inline-block;width:175px;"
                  @change="data => {pm.consigneeChange(data)}"
                />&nbsp;
                <el-button
                  no="consigneeBillAddress"
                  type="primary"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'consigneeLine'+i"
                  v-model="form['consigneeLine'+i]"
                  :no="'consigneeLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),'')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify,null)"
                />
              </el-form-item>
            </el-form>
            <el-form
              :disabled="readonly"
              label-width="50px"
              label-position="right"
              style="position:relative;margin-right:10px"
            >
              <char-count :form="form" prefix="notify" />
              <el-form-item :label="$t('SeaExport.NotifyParty')">
                <cargo-company-select
                  no="notifyId"
                  :method-params="{notify:true,active:true,companyLob:'integratedJob'}"
                  :default-value="form.notifyId||''"
                  style="display: inline-block;width:175px;"
                  @change="data => {pm.notifyChange(data)}"
                />&nbsp;
                <el-button
                  no="noconifyBillAddress"
                  type="primary"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'notifyLine'+i"
                  v-model="form['notifyLine'+i]"
                  :no="'notifyLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),'')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify,null)"
                />
              </el-form-item>
            </el-form>
            <div>
              <span
                style="display:inline-block;line-height:28px;padding-bottom: 10px;"
              >{{ $t('SeaExport.SecondNotifyParty') }}</span>
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                :disabled="readonly"
                no="alsoNotify"
                :text-chars="0"
                style="width: 310px;height: 230px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify,null)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ContactPerson"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="right"
        label-width="100px"
      >
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="form"
      :agent="sopDialog.agent"
      lob="SE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="form"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="SE"
      :value="selectOperationReqDialog.value"
      @callback="val=>form.operationContent=val"
    />

    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import { TabInternationalCardBasePM } from './tabInternationalCardBasePM'
import sopPic from '@/assets/sop.png'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import hsCodeSearchDialog from '@/components/Cargo/Job/hsCodeSearchDialog'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'
import selectSurchargeTermsDialog from '@/components/Cargo/Job/selectSurchargeTermsDialog'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import selectData from '@/utils/selectData'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import { CARGO_SOURCES, EXPORT_CONTROLLED_PRODUCT, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { User } from '@/class/model/sys/User'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { Contract } from '@/class/model/mdm/Contract'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { validateReleaseNumberCustomer } from '@/api/company'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import lang from '@/lang'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import stampIcon from '@/assets/stamp.jpg'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import checkPermission from '@/utils/permission'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import BookingIntegratedDataGrid from '@/components/Cargo/Job/bookingIntegratedDataGrid'
import { basicCacheKeys } from '@/utils/cacheConfig'
import BillAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { checkPoNoIsExist } from '@/api/booking/job'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabInternationalCardBase',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    BillAddressDialog,
    BookingIntegratedDataGrid,
    AutoNumberInput,
    StampPictureView,
    cargoAdvanceSelect,
    cargoInput,
    cargoButtonContainer,
    sopDialog,
    soNoInput,
    transcribeDialog,
    hsCodeSearchDialog,
    cargoDepartmentNewSelect,
    cargoDepartmentSelect,
    cargoOfficeSelect,
    cargoUserSelect,
    cargoCompanySelect,
    cargoProjectSelect,
    cargoPackingSelect,
    specialRequestsGrid,
    selectOperationReqDialog,
    selectSurchargeTermsDialog,
    cargoRichTextarea,
    specialCharacterTip,
    CargoSalesCompanySelect
  },
  mixins: [BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      default: ''
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    },
    integratedLogisticsType: { type: String, default: '' },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabInternationalCardBasePM(this),
      sopPic,
      SEUtils,
      URL,
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      contractStatuses: selectData.contractStatuses,
      containerLoadTypes: ContainerLoadType.IE_TYPES,
      operateTypes: ContainerLoadType.OPERATE_TYPES,
      EXPORT_CONTROLLED_PRODUCT,
      CARGO_SOURCES,
      TAX_NATURES,
      bookingTerms: BOOKING_TERMS,
      partnerManagementMode: 0,
      isHC: false,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      creditOpen: false,
      openWarehouse: false,
      sopConfigOpen: false,
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      addrPM: new BillAddressCommonPM(this),
      form: new IntegratedJob().fillDefaultValue().getData(),
      seaEqList: [],
      isInputMbl: true, // 是否允许手动输入MBL,默认允许
      mblConfig: {
        visible: false,
        rule: '',
        identificationCode: '',
        curRule: null
      },
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        shipperLine7: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        consigneeLine7: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        notifyLine7: null
      },
      showWarningImageA: false,
      warningImageATip: '',
      showWarningImageB: false,
      warningImageBTip: '',
      showWarningImageC: false,
      warningImageCTip: '',
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      contractStatus: 0,
      contractStatusLabel: '',
      customerTip: '',
      contactList: [],
      etdEnabled: false,
      cargoSourceEnabled: false,
      warehouseNameList: [],
      salesList: null,
      salesPrompt: '',
      txtWhs: '', // 入库信息
      txtSalesOffice: '', // 销售所在分公司
      overseaAgentUsersList: [], // 海外客服用户列表
      txtSurchargeTerms: '', // 附加费条款
      contactDialog: {
        visible: false,
        data: {}
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      transcribeDialog: {
        visible: false
      },
      hsCodeSearchDialog: {
        visible: false,
        title: '',
        successCallback: () => {
        }
      },
      selectOperationReqDialog: {
        visible: false,
        value: ''
      },
      selectSurchargeTermsDialog: {
        visible: false,
        rowData: []
      },
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      isTabContainerInfo: true, // // CARGO-7908 当基本页签切换非装箱信息页签不去覆盖基本页签实际件毛体(cargo 中在bookingworkspace 中设置的是true)
      btnSave: true,
      bookingAgentDataProviderChange: false, // 订舱代理数据源是否发生变更
      customerRefNoTip: '', // 业务参考号鼠标悬浮提示
      markChange: false,
      cargoEnglishNameChange: false,
      oldMark: '',
      oldCargoEnglishName: '',
      showMarkOrCargoEnglishNameDialog: false, // 英文品名唛头是否双击展示
      countryList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      billAddressDialog: {
        visible: false
      },
      openProjectConfig: false,
      poNoRed: false,
      needConfirmProjectNo: false,
      isProjectLinkedCustomer: false,
      cargoSalesList: null,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false, // 显示中邮选项
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      trustFromEditSales: false // 交叉委托编辑销售
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.form.printHblZbLock && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditBookingTab'])))
    },
    isSelectDisabled() {
      return !this.isEdit || this.integratedLogisticsType === ContainerLoadType.STUFFY_IC.code
    },
    mblEditable() {
      return !checkPermission(['button_SEBooking_generateMBL'])
    },
    bookingAgentEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'bookingAgent') && ((this.pm.isJoinCarrierBookingAgent && this.form.containerLoadType !== 'BB') ? this.form.carrierId > 0 : true)
    },
    carrierIdEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'carrierId')
    },
    designationAgentEnabled() {
      return this.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'designationAgent')
    },
    customsBrokerEnabled() {
      if (!this.form.customs) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customsBroker')) {
        return false
      }
      return true
    },
    warehouseEabled() {
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'warehouseCmp')) {
        return false
      }
      return true
    },
    cubageActualEnabled() {
      return this.isEdit && !this.pm.billChargeFlag && SecurityUtil.checkOffsetChargeMeasure(this.form, 'WCB')
    },
    config() {
      return this.context.config
    },
    customerEnabled() {
      // 开启参数1 且是被委托的业务，不可以改委托单位；
      if (this.config && Number(this.config.get('isNewDelegation')) === 1 && this.form.trustFromJob) {
        return false
      }
      return this.isEdit && (this.trustFromEditSales ? true : !this.form.relatedJob) && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customerId')
    },
    chargeWeightEnabled() {
      return this.isEdit && SecurityUtil.checkOffsetChargeMeasure(this.form, 'WGTX')
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    },
    // 是否存在主票
    hasMaster() {
      return !!this.form.lclMasterUuid
    }
  },
  watch: {
    'form.transfering': {
      handler(value) {
        if (!value) {
          this.form.transferPortCode = ''
        }
      },
      deep: true
    }
  },
  created() {
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.creditOpen = Number(this.config.get('creditOpen')) === 1
    this.markChange = false
    this.cargoEnglishNameChange = false
    this.isProjectLinkedCustomer = Number(this.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
    this.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.isShowContactPersonDetail = String(this.config.get('ToExoSystem')) === 'HC'
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.pm.init()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (!isRefresh) {
        this.pm.formInitialValue = { ...this.form }
        return
      }
      this.openProjectConfig = Number(this.config.get('openProjectConfig')) === 1
      this.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
      this.openWarehouse = Number(this.config.get('isOpenWarehouse')) > 0
      const job = new IntegratedJob(row)
      if (!row.uuid) {
        this.seaEqList = job.containerUsages = job.containerUsages || []
        this.customerLevel.level = ''
        this.customerLevel.customerName = ''
        this.advancePaymentLabel = ''
        this.contractStatus = 0
        this.contractStatusLabel = ''
        this.customerTip = ''
      } else {
        this.seaEqList = job.containerUsages || []
      }
      this.form = row
      if (!this.form.operateType) {
        this.form.operateType = ContainerLoadType.DIRECT.code
      }
      this.overseaAgentUsersList = []
      console.log('this.form===', this.form)
      this.checkSpecialCharacter()
      this.pm.changeJob()
      this.pm.fillView()
      this.loadCustomerIdContractInfo()
      this.cargoSourceEnabled = this.isEdit
      this.salesList = null
      this.salesPrompt = ''
      row.printHblZbLock = false
      this.bookingAgentDataProviderChange = false
      JobUtils.setSailingDay(this.form)
      if (this.isEdit) {
        this.oldMark = this.form.mark
        this.oldCargoEnglishName = this.form.cargoEnglishName
        this.setSecondaryCustomJobTypeFunc()
        this.setCustomJobTypeFunc()
      }
      if (!this.isEdit && this.form.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(this.form.poNo, this.form.uuid).then(res => res.data) > 0
      }
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness)
    },
    checkSpecialCharacter() {
      if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    showContactDialog() {
      if (!this.form.customerContact) {
        return
      }
      for (const item of this.contactList) {
        if (item.contactPerson === this.form.customerContact) {
          this.contactDialog.data = item
          this.contactDialog.visible = true
          return
        }
      }
      this.contactDialog.data = {}
      this.contactDialog.visible = true
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      if (title === this.$t('SeaExport.EnglishDescriptionOfGoods') || title === this.$t('SeaExport.Marks')) {
        this.showMarkOrCargoEnglishNameDialog = true
      }
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 加载委托单位签约信息
    async loadCustomerIdContractInfo() {
      let company = this.context.companyList.find(p => p.cmpIdx === this.form.customerId)
      this.showWarningImageB = false
      this.sopImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.stampPictureView.businessDocuments = []
      if (!company || !company.cmpIdx) {
        return
      }
      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
      }
      await this.loadCustomerDetial(company)
      this.pm.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
    },
    // 判断选中的委托单位，是否禁止到期合同创建业务，CARGO-7885
    async customerIdChange2ContractHandler(company) {
      this.showWarningImageB = false
      this.sopImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.cargoSalesList = null
      this.form.customerContact = ''
      this.form.editCftMode = false
      this.stampPictureView.businessDocuments = []
      if (this.form.customerId && parseInt(this.form.customerId) > 0) {
        this.form.preCustomerId = this.form.customerId
      }
      if (!company.cmpIdx) {
        this.form.customerId = 0
        if (this.form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
          this.txtSalesOffice = ''
          this.form.sales = ''// 销售
          // 如果开启分公司过滤参数，查出来所有分公司
          let officeSaleList
          if (this.salesOfficeCheck) {
            officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
          } else {
            officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
          }
          this.salesList = officeSaleList
        }
        this.pm.getTxtSalesPrompt()
        return
      }
      const validateRes = await validateReleaseNumberCustomer({
        companyId: company.cmpIdx,
        officeId: this.$store.getters.currentOfficeId
      })
      if (validateRes && validateRes.data && validateRes.data.allowed === false) {
        if (validateRes.data.message) {
          this.$message.warning(validateRes.data.message)
        }
        this.form.customerId = 0
        console.log('[ReleaseNumber] Integrated Card clear', !!this.$refs.customerSelect)
        if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
          this.$refs.customerSelect.clear()
        }
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.form.uuid))
      // 这个验证必须在 this.form.customerId = company.cmpIdx 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(this.form, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.form.customerId = company.cmpIdx

      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
        this.pm.checkNewJobCreditInfo()
      }
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.form.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }

      // 合同限制校验：检查是否启用合同限制且可放号天数<=0
      const contractLimitEnabled = company.contractLimitEnabled
      const availableDays = company.availableReleaseDays

      // contractLimitEnabled 可能是 '1' 或 1
      if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
        // availableReleaseDays 可能是数字或字符串，需要转换
        const daysNum = parseInt(availableDays) || 0
        if (daysNum <= 0) {
          const companyName = company.chineseName || company.englishName || '该委托单位'
          this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
          this.form.customerId = 0
          if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
            this.$refs.customerSelect.clear()
          }
          return
        }
      }

      if (company.incoTerm) {
        const incoTerm = company.incoTerm.split(',')
        if (incoTerm.length > 0) {
          this.form.incoTerm = incoTerm[0]
        }
      }
      await this.loadCustomerDetial(company)
      this.pm.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
      const contact = this.getDefaultContact(this.contactList)
      this.form.customerContact = contact ? contact.contactPerson : ''
      this.pm.onCustomerContactLoad()
      this.pm.onCustomerDetailLoad()
      this.pm.loadCustomerPortDestinationAgents()
      this.pm.loadCompanyUser() // 销售
      if (company.mustInputScn) {
        this.form.editCftMode = true
      }
      this.context.reloadCharge = true
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness, true)
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    async loadCustomerDetial(company) {
      let customer = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
      this.advancePaymentLabel = company && company.ifAdvancePayment ? this.$t('Partners.IfAdvancePayment') : ''
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      if (customer) {
        customer = new Customer(customer)
        const customerType = await customer.getCustomerType()
        // console.log('customerType', customerType)
        if (customerType) {
          this.customerLevel.level = customerType.typeId
          this.customerLevel.customerName = this.isZh ? customerType.chineseName : customerType.englishName
        }
      }
    },
    async businessDateChange(value) {
      this.form.businessDate = value
      this.form.businessDateDay = JobUtils.dateChange(this.form.businessDate)
      if (Number(this.config.get('IEBookingSyncBusidatetoETD')) === 1) {
        this.form.etd = value
        this.form.sailingDay = JobUtils.dateChange(this.form.etd)
      }
      await ChargeUtils.updateETDFee(this.form, this.form.businessDate, this.context, true)
    },
    async etdChange(value) {
      this.form.etd = value
      this.form.sailingDay = JobUtils.dateChange(this.form.etd)
      await ChargeUtils.updateETDFee(this.form, this.form.etd, this.context)
    },
    async atdChange(value) {
      this.form.atd = value
      this.form.atdSailingDay = JobUtils.dateChange(this.form.atd)
    },
    async etaChange(value) {
      this.form.eta = value
      this.form.etaSailingDay = JobUtils.dateChange(this.form.eta)
    },
    async ataChange(value) {
      this.form.ata = value
      this.form.ataSailingDay = JobUtils.dateChange(this.form.ata)
    },
    loadingPortCodeCharge(data) {
      this.form.loadingPortCode = data.value
      if (this.form.loadingPortCode) {
        const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', this.form.loadingPortCode)
        if (port) {
          const country = port.countryCode ? getObjectByCache(basicCacheKeys.basic_data_Country, 'code', port.countryCode) : ''
          if (country) {
            this.form.polCountry = country.name
          }
        }
      } else {
        this.form.polCountry = ''
      }
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    quantityActualChange() {
      SEUtils.changeQWCRule(null, () => { this.form.quantityContract = this.form.quantityActual })
      this.pm.changeSynBillOfLadingQWC()
      this.pm.txtPackingChangeHandler()
      this.pm.refContainerUsageQwc(2)
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].quantity = this.form.quantityActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
    },
    async weightContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
      }
      this.pm.jobContractQwcChange(2)
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.weightContract !== this.form.weightActual) {
          this.form.weightContract = this.form.weightActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
          }
        }
      })
      this.pm.calculateChargeWeight()
      this.pm.refContainerUsageQwc(2)
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].weight = this.form.weightActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
      }
      this.pm.jobContractQwcChange(3)
    },
    async cubageActualChange() {
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.cubageContract !== this.form.cubageActual) {
          this.form.cubageContract = this.form.cubageActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
          }
          this.form.chargeWeight = this.form.cubageActual
        }
      })
      this.pm.calculateChargeWeight()
      this.pm.refContainerUsageQwc(2, false)
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].cubage = this.form.cubageActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
    },
    transcribeCallback(data) {
      for (const key in data) {
        this.form[key] = data[key]
      }
    },
    showHsCodeSearchDialog(title, successCallback) {
      this.hsCodeSearchDialog.title = title
      this.hsCodeSearchDialog.successCallback = successCallback
      this.hsCodeSearchDialog.visible = true
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.form.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.form.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    async getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      this.$refs.cargoTextarea1.hanldeFormat()
      this.$refs.cargoTextarea2.hanldeFormat()
      await this.validateForm()
      // 校验 装箱和基本页签的件毛体是否一致
      const msg = ContainerUtil.validateContainerUsage(this.form)
      if (msg) {
        throw new TabError(msg, 'tabInternationalCardBase')
      }

      if (this.form.customerContact) {
        for (const item of this.contactList) {
          if (item.contactPerson === this.form.customerContact) {
            this.form.contactEmail = item.email
          }
        }
      }
      // CARGO-23318 订舱页签的 主单号栏位 和SONO.栏位 保存数据时自动去除空格
      if (this.form.mbl) {
        this.form.mbl = this.form.mbl.trim()
      }
      if (this.form.soNo) {
        this.form.soNo = this.form.soNo.trim()
      }
      const job = { ...this.form }
      job.clearTeu = true
      if (this.form.containers) {
        for (const container of this.form.containers) {
          if (container.containerUsage) {
            for (const item of container.containerUsage) {
              if (item.poItems === '') {
                item.poItems = []
              }
            }
          }
        }
      }
      return {
        job,
        seaEQ: this.form.seaEQ,
        delseaEQUuids: this.form.delseaEQUuids,
        containers: this.form.containers,
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids // 删除的装箱uuid
      }
    },
    async validateForm() {
      const form = this.form
      if (form.customerId < 1) {
        throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabInternationalCard')
      }
      await JobUtils.checkCustomerBranchScope(form, 'tabInternationalCard')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), form.customerId, 'tabInternationalCard')
      if (form.bookingAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BookingAgent'), form.bookingAgent, 'tabInternationalCard')
      }
      if (form.destinationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.DestinationAgent'), form.destinationAgent, 'tabInternationalCard', 'englishName')
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && form.designationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent, 'tabInternationalCard', 'englishName')
      }
      if (form.customsBroker) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CustomsBroker'), form.customsBroker, 'tabInternationalCard')
      }
      if (form.warehouseCmp) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.Warehouse'), form.warehouseCmp, 'tabInternationalCard')
      }
      if (form.carryingCmp) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.HaulageCompany'), form.carryingCmp, 'tabInternationalCard')
      }
      if (form.carrierId) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.ShippingCompany'), form.carrierId, 'tabInternationalCard')
      }
      if (form.carrierAgentId) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CarrierAgent'), form.carrierAgentId, 'tabInternationalCard')
      }
      if (!form.containerLoadType) {
        throw new TabError(this.$t('Message.FLCLTypeCannotBeNull'), 'tabInternationalCard')
      }
      if (form.transfering && (!form.transferPortCode || !this.checkSeaport(form.transferPortCode))) {
        throw new TabError(this.$t('Message.IfThereIsATransferTheTransferPortCannotBeNull'), 'tabInternationalCard')
      }
      if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
        if (!form.sales) {
          throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabInternationalCard')
        }
        if (!form.salesOffice) {
          throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabInternationalCard')
        }
        if (!form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabInternationalCard')
        }
      } else {
        if (form.sales && !form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabInternationalCard')
        }
      }
      if (!form.businessDate) {
        throw new TabError(this.$t('Message.BusinessDateCanNotNull'), 'tabInternationalCard')
      }
      if (form.etd && form.eta && form.eta < form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeLaterThanDateOfArrival'), 'tabInternationalCard')
      }
      if (form.cargoSource === 'NC' && !form.designationAgent) {
        throw new TabError(this.$t('Message.NominatedAgentCannotBeNull'), 'tabInternationalCard')
      }
      if (this.config.get('SERequirePONO') === '1' && !form.poNo) {
        throw new TabError(this.$t('Message.ItemNoCannotBeNull'), 'tabInternationalCard')
      }
      if (form.containerLoadType === 'TT') {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.EQSizeCannotBeNull'), 'tabInternationalCard')
        }
      }
      if (!form.opDepartment) {
        throw new TabError(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'tabInternationalCard')
      }
      if (!form.loadingPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_loadingPortCode') + this.$t('CargoMsg.Cargo_CanNotEmpty'), 'tabInternationalCard')
      }
      if (!form.dischargingPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_dischargingPortCode') + this.$t('CargoMsg.Cargo_CanNotEmpty'), 'tabInternationalCard')
      }
      if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabInternationalCard')
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabInternationalCard')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabInternationalCard')
      }
    },
    // 校验海港
    checkSeaport(code) {
      const obj = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', code)
      return Boolean(obj)
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      const reqKeys = this.getRequestSelectedKeys()
      params.REQUEST_UUID = (!reqKeys || reqKeys.length === 0 ? '' : reqKeys)
      params.category = 'BOOKING'
      params.ctx = new IntegratedJob(this.form)
      return params
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = { jobUuid: this.form.uuid, docKeys: documentType.uuid }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    /**
     * 客户特殊要求
     */
    getRequestSelectedKeys() {
      return this.$refs['selectedSpecialRequest'].getRequestSelectedKeys() || []
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    executeTask() {
      // 保存客户发运信息
      this.addrPM.job = this.form
      if (parseInt(this.config.get('syncMailingAddress')) === 1) {
        this.addrPM.jobSaveCheck()
      }
    },
    async changeProject() {
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.form.poNo).then(res => {
          return res.data
        })
        if (company && this.form.customerId !== company.cmpIdx && company.active) {
          await this.customerIdChange2ContractHandler(company)
        }
      }
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.form.poNo = ''
        this.form.projectName = ''
      }
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.form, warehouseCallback: warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }) })
    },
    onCarrierIdChange() {
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    onCustomJobTypeChange() {
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
      this.form.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.form.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.form.customJobType, this.form.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
